import { Redirect, Stack } from 'expo-router';

import useAuth from '@fhs-legacy/frontend/src/hooks/auth/use-auth';
import AccountInfoPage from '@fhs-legacy/frontend/src/pages/account/account-info';
import { routes } from '@fhs-legacy/frontend/src/utils/routing';

export { ErrorBoundary } from '@fhs/routing/src/components/page-dev-error-boundary';

export default function AccountInfoRoute() {
  const { isAuthenticating, isAuthenticated } = useAuth();

  if (!isAuthenticating && !isAuthenticated) {
    return (
      <>
        <Stack.Screen options={{ headerShown: false }} />
        <Redirect href={routes.signIn} />
      </>
    );
  }

  return <AccountInfoPage />;
}
